import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-p404-component',
  templateUrl: './p404-component.component.html',
  styleUrls: ['./p404-component.component.css']
})
export class P404ComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/p404-component/p404-component.component.ts